// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"2525b4b2","482":"94ea3f5e","816":"f5d39800"}[chunkId] + ".chunk.js";
};